export const PUBLIC_API_SETTINGS = '/api/dashboard/public-api/api_keys'
